import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground border-border",
        // Powertrain variants
        ev: "border-transparent bg-green-600 text-white",
        benzin: "border-transparent bg-amber-500 text-white",
        diesel: "border-transparent bg-gray-600 text-white",
        // Body type
        bodyType: "border-transparent bg-primary/10 text-primary",
        // Price type
        priceFrom: "border-transparent bg-accent/10 text-accent font-bold",
        priceList: "border-transparent bg-secondary text-secondary-foreground",
        priceCampaign: "border-transparent bg-green-100 text-green-700",
        // Status
        active: "border-transparent bg-green-100 text-green-700",
        inactive: "border-transparent bg-gray-100 text-gray-500",
        pinned: "border-transparent bg-accent text-accent-foreground",
        draft: "border-transparent bg-amber-100 text-amber-700",
        published: "border-transparent bg-green-100 text-green-700",
        upcoming: "border-transparent bg-amber-500 text-white",
        discontinued: "border-transparent bg-gray-500 text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />;
  }
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
